import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import Navbar from "../components/webpage/Navbar";
import Footer from "../components/webpage/Footer";

const MAX_LINES = 10;

// === DATA: 5 ARTICLES ===
const posts = [
  {
    id: 1,
    category: "Analiza JPK VAT",
    title:
      "Twoja firma widziana na nowo: czego nie widzisz w danych, które już masz w JPK VAT?",
    date: "2025-01-10",
    readTime: "8 min",
    content: `
Bez względu na to, czy prowadzisz niewielką firmę usługową, czy dużą spółkę handlową — jedno jest pewne: Twoje dane już istnieją. Co miesiąc i tak generujesz plik JPK VAT. I tak wysyłasz go do urzędu skarbowego. I tak przechowujesz go gdzieś na dysku czy w systemie księgowym.
Tylko… nikt z tego nie korzysta.

Właściciele firm często skupiają się na bieżącej działalności, a nie na analizie danych, które już mają „pod ręką”. Tymczasem JPK VAT to potężne źródło informacji — kompletna lista sprzedaży, zakupów, kontrahentów, regionów, klientów, dynamik, sezonowości. Dane, które firmy z reguły odkrywają dopiero przy audycie, kontroli albo problemie… są ukryte w JPK cały czas.

Dlatego powstało AnalizyIRaporty.pl — narzędzie, które jednym kliknięciem automatycznie przetwarza Twój plik JPK VAT i zamienia go w zestaw gotowych raportów, wykresów i analiz.
Nic nie konfigurujesz, nic nie ustawiasz, nic nie przygotowujesz.
Wgrywasz plik → masz wyniki.

Brzmi jak magia? Zobacz, co tak naprawdę kryje się w Twoich danych.

1. Większość firm nie widzi 80% informacji, które posiada

To nie brak danych blokuje rozwój firm.
To brak narzędzi, które potrafią je odczytać.

W praktyce:

– dane o kontrahentach są porozrzucane po fakturach, mailach i systemach,
– historia zakupów jest przechowywana w PDF-ach,
– sprzedaż regionalna w ogóle nie istnieje w żadnym systemie,
– analiza marż, trendów czy sezonowości jest „na oko”.

Tymczasem JPK VAT to prawda o Twojej firmie zapisana w jednym pliku — niezależnie od tego, czy korzystasz z Subiekta, Optima, Wapro, FakturaXL, enovy, Business Central czy czegokolwiek innego.

To gotowy materiał do:
– analizy sprzedaży i zakupów,
– sprawdzania kontrahentów,
– znajdowania błędów,
– odkrywania wzorców,
– identyfikowania ryzyk.

Problem w tym, że nikt nie ma czasu przeglądać pliku XML o wielkości 300–400 MB.
I właśnie tutaj wchodzi automat.

2. Jak działa automatyczna analiza JPK?

W AnalizyIRaporty.pl nie musisz:

✘ niczego instalować
✘ niczego ustawiać
✘ mapować kolumn
✘ wybierać parametrów
✘ znać XML-a
✘ robić czegokolwiek ręcznie

Całość działa jak Google Translate, tylko do danych firmowych.

Wgrywasz plik → algorytm automatycznie konwertuje go na strukturę danych → generuje gotowe raporty.

Co dokładnie generuje?

– raport sprzedaży i zakupów (miesiące, dni, kontrahenci, stawki VAT),
– raport regionalny (województwa, powiaty, miasta),
– raport cen, trendów, dynamik, sezonowości,
– raport kontrahenta (wiarygodność, zmiany, ryzyka),
– raport analityczny (marże, struktura zakupów, top suppliers),
– raport błędów i anomalii.

A wszystko to w kilka sekund.

3. Co możesz zobaczyć w danych, czego dziś w ogóle nie widzisz?

Poniżej kilka przykładów, które wyciąga automat — i to bez Twojej ingerencji.

✔ Trendy sprzedażowe

Który miesiąc jest najmocniejszy?
Który dzień tygodnia przynosi najwięcej transakcji?
Czy Twoja firma rośnie szybciej, niż myślisz?

✔ Regiony, które generują największy obrót

Zaskoczenie: wiele firm sprzedaje w miejscach, o których nie ma pojęcia.
Czasem połowa sprzedaży idzie do dwóch województw, a firma inwestuje reklamę w trzech innych.

✔ Klienci, którzy kupują najwięcej

Pełny ranking klientów (B2B) wyciągany z JPK bez żadnej pracy.

✔ Dynamika zakupów — spadki i wzrosty

Raport zakupowy potrafi ujawnić kluczowe zmiany:
– wzrost cen u dostawcy,
– spadek zakupów konkretnego towaru,
– niestandardowe obniżki VAT.

✔ Ukryte anomalie

Duplikaty, dziwne kwoty, nietypowe NIP-y, błędne stawki VAT — automat wyłapuje to wszystko.

4. Zero konfiguracji, zero wiedzy technicznej — tylko wyniki

Największą zaletą AnalizyIRaporty.pl jest to, że nie wymaga żadnej wiedzy księgowej ani analitycznej.

System sam:
– wczytuje JPK,
– wykrywa, czy to sprzedaż, zakup czy miks,
– normalizuje dane,
– czyści je,
– buduje indeksy,
– klasyfikuje kontrahentów,
– przypisuje regiony,
– generuje wykresy i raporty.

To znaczy, że:

👉 możesz zobaczyć kompletny obraz swojej firmy, nawet jeśli nie wiesz nic o księgowości
👉 możesz odkryć elementy, których nie widzą księgowi (bo Excel już tego nie ogarnia)
👉 możesz podejmować decyzje oparte na danych, nie na intuicji

To wszystko dzieje się automatycznie.

5. Dlaczego JPK to najpotężniejsze źródło danych w firmie?

Bo jest:
– pełny (wszystkie transakcje),
– uporządkowany,
– ustandaryzowany,
– comiesięczny,
– w identycznym formacie dla każdej firmy.

To w zasadzie Twój „Mini ERP”, tylko że schowany przed Tobą na co dzień.

Większość firm patrzy na JPK jak na obowiązek podatkowy.
My patrzymy jak na gotowe źródło do inteligentnej analityki.

6. Co zobaczysz w pierwszej minucie po wgraniu pliku?

– mapę sprzedaży po województwach,
– ranking klientów i dostawców,
– dynamikę miesiąc do miesiąca,
– wykryte anomalie,
– podział sprzedaży po stawkach VAT,
– wszystkie transakcje kontrahenta po wejściu w NIP,
– gotowy raport kontrahenta (to ważne — również automatyczny).

I to wszystko bez klikania i konfiguracji.

7. Co to daje w praktyce? (3 szybkie scenariusze)

🔸 Scenariusz 1 — diagnostyka firmy

Właściciel wgrywa JPK i widzi, że 40% sprzedaży idzie z jednego regionu.
Nigdy tego nie wiedział.
Zmienia strategię reklamową.

🔸 Scenariusz 2 — kontrola kontrahenta

Klik w NIP → gotowy raport wiarygodności (finanse, zarząd, ryzyka, sankcje).
Zero szukania.

🔸 Scenariusz 3 — szybkie odnajdywanie dokumentu

Klient pyta o fakturę sprzed 6 miesięcy.
Wpisujesz kwotę albo fragment nazwy → faktura gotowa.

8. Podsumowanie: Twoje dane już istnieją. Otwórz je.

Największy paradoks w polskich firmach?
Wysyłają do urzędu skarbowego dane, które mogłyby im pomóc rozwijać firmę.

AnalizyIRaporty.pl robi coś prostego i potężnego:

odkrywa to, co od lat leży ukryte w Twoich plikach JPK VAT — całkowicie automatycznie.

Jeśli chcesz:
– zobaczyć swoją firmę z zupełnie nowej perspektywy,
– odnaleźć każdy dokument w kilka sekund,
– przeanalizować klientów, regiony i trendy,
– sprawdzić wiarygodność kontrahenta,

…to potrzebujesz tylko jednego.

Wgrać swój plik JPK.

Resztę zrobi automat.
    `,
  },
  {
    id: 2,
    category: "Wyszukiwanie dokumentów",
    title:
      "Znajdź każdą fakturę w kilka sekund: inteligentna wyszukiwarka JPK VAT, która działa automatycznie",
    date: "2025-01-24",
    readTime: "6 min",
    content: `
W każdej firmie jest taki moment, kiedy ktoś musi odnaleźć jedną, konkretną fakturę.
Może to być:

– klient proszący o duplikat,
– księgowa potrzebująca potwierdzenia,
– dział finansów sprawdzający rozbieżność,
– właściciel szukający kwoty z zeszłego kwartału.

I wtedy zaczyna się klasyczny problem: gdzie to jest?
W PDF-ach? W mailach? W folderach? W systemie księgowym? W archiwum? W chmurze?

Firmy marnują dziesiątki godzin miesięcznie na coś, co powinno być natychmiastowe.

Dlatego stworzyliśmy w AnalizyIRaporty.pl funkcję, która rozwiązuje to raz na zawsze — automatyczną wyszukiwarkę wszystkich dokumentów zawartych w Twoim pliku JPK VAT.

Wystarczy wgrać plik → i już możesz znaleźć wszystko po:

– NIP-ie,
– nazwie,
– kwocie,
– dacie,
– numerze faktury,
– nawet po fragmencie wartości.

Bez ręcznego przetwarzania, bez konfiguracji, bez klikania czegokolwiek.

1. Dlaczego dokumenty w firmach się „gubią”?

Bo każda firma działa inaczej:

– część faktur jest w PDF-ach,
– część w mailach,
– część u księgowej,
– część na komputerze handlowca,
– część w systemie ERP,
– część tylko w JPK.

Przez to:

– dokumenty są rozproszone,
– szukanie trwa długo,
– nikt nie wie, gdzie czego szukać,
– a klienci lub księgowi często czekają na odpowiedź godzinami.

Tymczasem JPK VAT to… pełna baza danych wszystkich transakcji.

Jeśli więc masz JPK → masz wszystko.

2. Automatyczna wyszukiwarka faktur — jak to działa?

W AnalizyIRaporty.pl nie musisz:

✘ niczego indeksować,
✘ ustawiać filtrów,
✘ podłączać systemu księgowego,
✘ wprowadzać danych,
✘ pracować na Excelu.

Automat robi to sam.

Wgrywasz JPK → system sam buduje wyszukiwarkę dokumentów.

Możesz wyszukiwać po:

– nazwie firmy,
– NIP-ie,
– kwocie netto/brutto,
– numerze faktury,
– dacie,
– przedziale dat,
– stawce VAT,
– fragmencie opisu.

Działa to w ułamku sekundy — niezależnie od tego, czy Twój JPK ma 5 MB czy 400 MB.

3. Co można dzięki temu znaleźć w kilka sekund?

✔ Fakturę, której żąda klient

Nie musisz przeszukiwać maila sprzed 8 miesięcy.
Wpisujesz kwotę → faktura gotowa.

✔ Rozbieżności księgowe

Dziwna kwota?
Numer faktury z dopiskiem „/23”?
Jedno kliknięcie.

✔ Dokumenty od konkretnego dostawcy

Wpisujesz NIP → wszystkie dokumenty jak na dłoni.

✔ Faktury z błędnym VAT

Automat potrafi je wykryć i wyświetlić listę.

✔ Dokumenty do audytu

Audytorzy kochają tę funkcję.

4. Dlaczego to działa lepiej niż Excel czy ERP?

Bo:

– ERP-y nie mają pełnej historii JPK,
– Excele się zacinają,
– PDF-y są nieszukalne,
– a różne osoby w firmie nie mają tych samych danych.

JPK VAT ma wszystko.
A AnalizyIRaporty.pl robi wszystko automatycznie, bez potrzeby konfiguracji.

5. Podsumowanie: koniec z szukaniem dokumentów

Jeśli chcesz:

– znaleźć dowolną fakturę natychmiast,
– przeszukać całą historię sprzedaży i zakupów,
– pracować szybciej niż księgowość i ERP,
– odpowiadać klientom w kilka sekund —

Wgraj plik JPK do AnalizyIRaporty.pl.
Cała reszta dzieje się automatycznie.
    `,
  },
  {
    id: 3,
    category: "Raport wiarygodności",
    title:
      "Raport wiarygodności kontrahenta: jak ocenić ryzyko współpracy w 10 sekund?",
    date: "2025-02-02",
    readTime: "5 min",
    content: `
Firmy coraz częściej sprawdzają swoich klientów, dostawców i partnerów biznesowych.
Powód? Ryzyko finansowe jest największe właśnie tam, gdzie jest brak informacji.

Nie trzeba jednak przeszukiwać KRS, CEIDG, GUS, bazy dłużników, ani historii VAT.
Nie trzeba skakać po 10 stronach internetowych.
Nie trzeba znać wskaźników finansowych.

W AnalizaKontrahenta.pl oraz w AnalizyIRaporty.pl zrobiliśmy to inaczej:

👉 Wpisujesz NIP → raport wiarygodności tworzy się automatycznie.

Pełna ocena ryzyka, finanse, zmiany w zarządzie, powiązania, sankcje, stabilność, historia — wszystko w jednym miejscu.

1. Dlaczego w ogóle trzeba sprawdzać kontrahentów?

Powody są proste:

– nieuczciwi odbiorcy = niezapłacone faktury,
– firmy w złej kondycji = ryzyko upadłości,
– spółki-wydmuszki = problemy podatkowe,
– podmioty z sankcji = duże kary dla Ciebie,
– brak weryfikacji = brak bezpieczeństwa transakcji.

Jedna zła współpraca może kosztować więcej niż rok analiz.

2. Skąd pochodzą dane do raportu?

Raport wiarygodności w AnalizaKontrahenta.pl tworzy się automatycznie na podstawie:

– KRS,
– GUS,
– NIP/VAT,
– bazy dłużników,
– rejestrów zmian w zarządzie,
– danych finansowych (sprawozdania),
– list sankcyjnych (ONZ, UE, USA — jeśli połączone z modułem AML),
– danych transakcyjnych z JPK VAT (jeśli używasz AnalizyIRaporty.pl).

Wszystkie te dane pobiera automat.
Ty nie robisz nic.

3. Co zawiera raport wiarygodności?

– profil działalności firmy,
– status rejestracyjny (VAT, aktywność, formy prawne),
– powiązania właścicielskie,
– zmiany w zarządzie (często sygnał ostrzegawczy),
– ocena kondycji finansowej,
– analiza sprawozdania,
– zaległości i ostrzeżenia,
– historia współpracy z JPK (jeśli masz swoje dane),
– informacja o sankcjach i AML.

Całość powstaje automatycznie.

4. Jak wygląda to w praktyce?

Masz firmę z NIP-em.

Wpisujesz NIP.

System pobiera dane.

Gotowy raport PDF lub online — w 10 sekund.

Nie ma szybszej metody na rynku.

5. Najważniejsze: to nie jest „twardy raport finansowy”. To praktyczna ocena ryzyka.

Czy firma:

– działa stabilnie?
– ma normalny zarząd?
– nie ukrywa restrukturyzacji?
– nie znika co 6 miesięcy?
– nie zmienia nagle wspólników?
– nie ma ryzyk sankcyjnych?
– nie ma dziwnej struktury adresowej?

To najważniejsze pytania.
I właśnie na nie odpowiada automat.

6. Podsumowanie

Jeśli chcesz mieć pewność, że Twój kontrahent jest wiarygodny:

Wpisz NIP → resztę zrobi automat.

Raport wiarygodności w AnalizaKontrahenta.pl
i w AnalizyIRaporty.pl to jedno z najszybszych narzędzi do oceny ryzyka na rynku.
    `,
  },
  {
    id: 4,
    category: "Analiza regionalna",
    title:
      "Regionalna sprzedaż i analiza klientów: odkryj nowe rynki w danych z JPK VAT",
    date: "2025-02-12",
    readTime: "6 min",
    content: `
Jak myślisz — w których regionach Twoja firma sprzedaje najwięcej?
Kto kupuje najczęściej?
Gdzie rośniesz, a gdzie tracisz rynek?
Które województwa dają Ci największy potencjał?

Wiele firm… nie ma pojęcia.

Dlaczego?
Bo systemy księgowe w ogóle nie pokazują geografii sprzedaży.
Excel nie daje rady przy 50 000 transakcjach.
A dane z faktur są rozrzucone w PDF-ach.

Tymczasem JPK VAT zawiera wszystkie adresy i dane kontrahentów.

Dlatego w AnalizyIRaporty.pl zbudowaliśmy automatyczny raport regionalny, który tworzy:

– mapy Polski,
– zestawienia województw,
– podziały po miastach i powiatach,
– wzrosty i spadki rok do roku,
– ranking regionów,
– sezonowość sprzedaży.

Nic nie musisz ustawiać — raport tworzy się sam po wgraniu JPK.

1. Dlaczego analiza regionalna jest tak ważna?

Bo odpowiada na kluczowe pytania:

– gdzie najlepiej działa Twój marketing?
– gdzie warto otworzyć oddział?
– gdzie warto zwiększyć budżet reklamowy?
– które miasta są niedocenione?
– gdzie rośnie zapotrzebowanie?

Wiele firm odkrywa zaskakujące rzeczy:

„Myśleliśmy, że najwięcej sprzedajemy w Warszawie, a tymczasem największe wzrosty mamy w Rzeszowie.”

2. Jak działa raport regionalny w AnalizyIRaporty.pl?

Po wgraniu JPK VAT:

– wszystkie adresy kontrahentów są automatycznie rozpoznawane,
– system sam przypisuje województwa i miasta,
– tworzy ranking,
– generuje mapy i wykresy,
– analizuje trendy miesięczne i roczne.

To dzieje się w pełni automatycznie, bez ręcznej pracy.

3. Co zobaczysz w kilka sekund?

– mapa sprzedaży Polski,
– ranking top miast,
– średnie wartości transakcji per region,
– sezonowość per województwo,
– segmenty klientów regionalnie,
– gdzie tracisz, a gdzie zyskujesz rynek.

4. Przykład zastosowania

Firma budowlana odkryła, że:

– 60% sprzedaży generują 3 województwa,
– a budżet reklamowy był skierowany do innych 5.

Po zmianie kampanii — wzrost konwersji o 38%.

To właśnie potęga danych, które już masz w JPK.

5. Podsumowanie

Jeśli chcesz odkryć:

– gdzie rośniesz,
– gdzie tracisz rynek,
– gdzie masz największych klientów,

…wystarczy jedno:

Wgraj JPK do AnalizyIRaporty.pl.
Raport regionalny zrobi się automatycznie.
    `,
  },
  {
    id: 5,
    category: "AML i sankcje",
    title:
      "Automatyczna kontrola kontrahentów: AML, sankcje, bazy dłużników — zero ryzyka, zero ręcznej pracy",
    date: "2025-02-20",
    readTime: "7 min",
    content: `
Co łączy branże:

– księgowość,
– pośrednictwo finansowe,
– nieruchomości,
– doradców,
– sklepy internetowe,
– brokerów?

Wszystkie podlegają obowiązkom AML oraz muszą pilnować, aby nie współpracować z podmiotami z list sankcyjnych.

Problem?
Większość firm nie ma narzędzi, żeby to robić dobrze.
A brak weryfikacji może kosztować dziesiątki tysięcy złotych.

Dlatego powstało AnalizyIRaporty.pl.

👉 Wpisujesz NIP → system sam sprawdza wszystkie wymagane bazy.
Bez osobnych rejestrów.
Bez szukania.
Bez ryzyka.

1. Kogo dotyczą obowiązki AML?

AML dotyczy m.in.:

– biur rachunkowych,
– doradców podatkowych,
– pośredników kredytowych,
– firm pożyczkowych,
– kancelarii prawnych,
– agentów nieruchomości,
– spółek obracających towarami wartościowymi,
– operatorów usług wirtualnych,
– wielu firm B2B, które nie wiedzą, że podlegają ustawie.

2. Jakie bazy należy sprawdzać?

W praktyce:

– listy sankcyjne UE,
– listy sankcyjne ONZ,
– lista OFAC USA,
– krajowe wykazy MF,
– wykaz podmiotów powiązanych,
– baza dłużników,
– KRS/GUS/CEIDG,
– rejestr VAT.

Normalnie — trzeba to robić ręcznie.
W AnalizyIRaporty.pl → robi to automat.

3. Jak działa automatyczna kontrola kontrahenta?

Wpisujesz NIP lub nazwę.

System pobiera dane.

Sprawdza wszystkie bazy jednocześnie.

Tworzy jednolity raport ryzyka.

Podświetla wyniki: zielony / żółty / czerwony.

Cała analiza trwa 2–4 sekundy.

4. Dlaczego automat jest lepszy niż ręczna weryfikacja?

Bo:

– niczego nie przegapisz,
– wyniki są aktualne w dniu sprawdzenia,
– masz dowód wykonanej weryfikacji (PDF),
– możesz sprawdzić setki firm dziennie,
– raporty zawsze wyglądają tak samo,
– system działa nawet dla mikrobiznesów.

5. Podsumowanie

Jeśli chcesz:

– spełniać obowiązki AML,
– unikać kar,
– nie współpracować z firmami z sankcji,
– zabezpieczyć swoje transakcje,
– mieć pełną kontrolę nad kontrahentami,

to potrzebujesz tylko jednego:

Wpisz NIP → resztę zrobi automat.
Dzięki AnalizyIRaporty.pl.
    `,
  },
];

// Helper: get preview = first N non-empty lines
const getPreview = (text, maxLines = MAX_LINES) => {
  const lines = text.split("\n");
  const nonEmpty = lines.filter((l) => l.trim() !== "");
  if (nonEmpty.length <= maxLines) return text.trim();

  const sliced = nonEmpty.slice(0, maxLines).join("\n");
  return `${sliced}\n\n[...]`;
};

const Blog = () => {
  const [expanded, setExpanded] = useState({}); // { [id]: true/false }

  const togglePost = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <>
      <Navbar />
      <PageBackground>
        <ContentWrapper>
          <HeroSection>
            <HeroBadge>Blog</HeroBadge>
            <HeroTitle>
              Wiedza o sprzedaży, zakupach
              <span> i danych z JPK VAT w praktyce</span>
            </HeroTitle>
            <HeroSubtitle>
              Przykłady zastosowań AnalizyIRaporty.pl: od wyszukiwarki faktur,
              przez raporty regionalne, po automatyczną kontrolę kontrahentów.
            </HeroSubtitle>
          </HeroSection>

          <MainLayout>
            <PostsSection>
              {posts.map((post) => {
                const isExpanded = !!expanded[post.id];
                const textToShow = isExpanded
                  ? post.content.trim()
                  : getPreview(post.content);

                return (
                  <PostCard key={post.id}>
                    <PostCategory>{post.category}</PostCategory>
                    <PostTitle>{post.title}</PostTitle>
                    <PostMeta>
                      <span>{post.date}</span>
                      <Dot>•</Dot>
                      <span>{post.readTime} czytania</span>
                    </PostMeta>

                    <PostContent>{textToShow}</PostContent>

                    <ReadMoreButton onClick={() => togglePost(post.id)}>
                      {isExpanded ? "Pokaż mniej" : "Pokaż więcej"}
                    </ReadMoreButton>
                  </PostCard>
                );
              })}
            </PostsSection>

            <Sidebar>
              <SidebarCard>
                <SidebarTitle>Tematy na blogu</SidebarTitle>
                <TagsWrapper>
                  <Tag>#JPK_VAT</Tag>
                  <Tag>#analiza_sprzedaży</Tag>
                  <Tag>#wyszukiwarka_faktur</Tag>
                  <Tag>#raport_wiarygodności</Tag>
                  <Tag>#analiza_regionalna</Tag>
                  <Tag>#AML</Tag>
                </TagsWrapper>
              </SidebarCard>

              <SidebarCard>
                <SidebarTitle>Dla kogo jest ten blog?</SidebarTitle>
                <SidebarText>
                  Dla właścicieli firm, dyrektorów finansowych, kontrolerów,
                  analityków oraz biur rachunkowych, które chcą wykorzystać
                  JPK VAT do realnej analizy biznesu.
                </SidebarText>
              </SidebarCard>

              <SidebarCard>
                <SidebarTitle>Chcesz zobaczyć to na żywo?</SidebarTitle>
                <SidebarText>
                  Umów krótkie DEMO, a pokażemy raporty z Twoich własnych
                  danych JPK VAT – bez konfiguracji i bez instalacji.
                </SidebarText>
                <SidebarCTA href="/register-demo">
                  Zarezerwuj DEMO →
                </SidebarCTA>
              </SidebarCard>
            </Sidebar>
          </MainLayout>
        </ContentWrapper>
      </PageBackground>
      <Footer />
    </>
  );
};

export default Blog;

// === STYLES ===

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const PageBackground = styled.div`
  padding: 3rem 1rem 4rem;
  background: url("/back.jpg") no-repeat center center fixed;
  background-size: cover;
`;

const ContentWrapper = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  animation: ${fadeIn} 0.6s ease-out;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
`;

const HeroSection = styled.section`
  padding: 2.5rem 2rem 1.5rem;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.9);
  margin-bottom: 2rem;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    padding: 1.75rem 1.25rem;
  }
`;

const HeroBadge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  background: rgba(59, 195, 204, 0.12);
  color: #08808a;
  margin-bottom: 0.75rem;
`;

const HeroTitle = styled.h1`
  font-size: 2.2rem;
  line-height: 1.2;
  margin: 0 0 0.75rem;
  color: #111;

  span {
    display: block;
    font-weight: 500;
    color: #444;
  }

  @media (max-width: 768px) {
    font-size: 1.75rem;
  }
`;

const HeroSubtitle = styled.p`
  margin: 0;
  font-size: 1rem;
  color: #555;
  max-width: 620px;
`;

const MainLayout = styled.div`
  display: grid;
  grid-template-columns: 2.2fr 1fr;
  gap: 1.75rem;
  margin-top: 1rem;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const PostsSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const PostCard = styled.article`
  padding: 1.5rem 1.6rem;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.03);
  transition: transform 0.25s ease, box-shadow 0.25s ease, border 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.09);
    border-color: rgba(59, 195, 204, 0.4);
  }
`;

const PostCategory = styled.div`
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #888;
  margin-bottom: 0.4rem;
`;

const PostTitle = styled.h2`
  font-size: 1.25rem;
  margin: 0 0 0.4rem;
  color: #111;
`;

const PostMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  color: #777;
  margin-bottom: 0.5rem;
`;

const Dot = styled.span`
  font-size: 0.9rem;
`;

const PostContent = styled.p`
  margin: 0 0 0.9rem;
  font-size: 0.95rem;
  color: #555;
  white-space: pre-line; /* zachowuje \n jako nowe linie */
`;

const ReadMoreButton = styled.button`
  border: none;
  outline: none;
  padding: 0.45rem 1.1rem;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  background: linear-gradient(135deg, #3bc3cc, #0f9fa9);
  color: #fff;
  box-shadow: 0 8px 20px rgba(59, 195, 204, 0.45);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px) scale(1.02);
    box-shadow: 0 10px 28px rgba(59, 195, 204, 0.65);
  }
`;

const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const SidebarCard = styled.div`
  padding: 1.3rem 1.4rem;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.06);
`;

const SidebarTitle = styled.h3`
  margin: 0 0 0.75rem;
  font-size: 1rem;
  color: #111;
`;

const SidebarText = styled.p`
  margin: 0;
  font-size: 0.95rem;
  color: #555;
`;

const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
`;

const Tag = styled.span`
  padding: 0.25rem 0.7rem;
  border-radius: 999px;
  background: rgba(59, 195, 204, 0.12);
  color: #08808a;
  font-size: 0.8rem;
`;

const SidebarCTA = styled.a`
  display: inline-flex;
  margin-top: 0.85rem;
  font-size: 0.9rem;
  text-decoration: none;
  color: #08808a;
  font-weight: 600;
  border-bottom: 1px solid transparent;
  padding-bottom: 1px;
  transition: color 0.2s ease, border-color 0.2s ease;

  &:hover {
    color: #05565c;
    border-color: rgba(8, 128, 138, 0.5);
  }
`;
